const options = {
  5: "bg-zinc-200/5",
  10: "bg-zinc-200/10",
  25: "bg-zinc-200/25",
  50: "bg-zinc-200/50",
  75: "bg-zinc-200/75",
  90: "bg-zinc-200/90",
  100: "bg-zinc-200",
};

const from = {
  5: "from-zinc-200/5",
  10: "from-zinc-200/10",
  25: "from-zinc-200/25",
  50: "from-zinc-200/50",
  75: "from-zinc-200/75",
  90: "from-zinc-200/90",
  100: "from-zinc-200",
};

export default function getBackgroundZinc200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
